import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { LinkAdditionalOrganisation } from "../../splash-screen/LinkAdditionalOrganisation";

export const LinkAdditionalOrganisationDialogBox = (props: {
  open: boolean;
}) => {
  const [openDialog, setOpen] = React.useState(props.open);

  useEffect(() => {
    setOpen(Boolean(props.open));
  }, [props.open]);

  const handleClose = (event: any, reason: any) => {
    if (reason && reason == "backdropClick") 
     return;
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={handleClose}
      >
        <LinkAdditionalOrganisation onClose={handleClose}/>
      </Dialog>
    </div>
  );
};
